import {Button, Modal, Rate, Space, Table, Tooltip} from "antd";
import type {ColumnsType} from "antd/es/table";
import {StyledDescriptionText} from "../../calls/upcoming-calls/upcoming-calls.style";
import moment from "moment";
import {SingleReviewsApiResponse} from "../../../react-query-hooks/reviews/types";
import {useState} from "react";
import {StyledModalContentWrapper} from "../../calls/upcoming-calls/call-card/new/styles";

interface DataType {
  key: string;
  customer: string;
  email: string;
  comment: string;
  offering: string;
  rating: string;
  date: string;
}

type ReviewsTableProps = {
  reviews: SingleReviewsApiResponse[];
};

export function ReviewsTable({reviews}: ReviewsTableProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [commentModalDetails, setCommentModalDetails] = useState("");

  const showModal = (text: string) => {
    setIsModalOpen(true);
    setCommentModalDetails(text);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };
  function handleRatingText(rating: number) {
    if (rating >= 0 && rating < 2) {
      return "Terrible";
    }
    if (rating >= 2 && rating < 3) {
      return "Bad";
    }
    if (rating >= 3 && rating < 4) {
      return "Average";
    }
    if (rating >= 4 && rating < 5) {
      return "Good";
    }
    if (rating >= 5) {
      return "Excellent";
    }
  }
  const columns: ColumnsType<DataType> = [
    {
      title: "Name",
      dataIndex: "customer",
      fixed: "left",
      width: "15rem",
      key: "name",
      render: (text) => (
        <>
          <StyledDescriptionText>{text}</StyledDescriptionText>
        </>
      ),
    },
    {
      title: "Email",
      dataIndex: "email",
      width: "15rem",
      key: "email",
      render: (text) => (
        <>
          <Tooltip title={text}>
            <StyledDescriptionText>{text}</StyledDescriptionText>
          </Tooltip>
        </>
      ),
    },
    {
      title: "Comment",
      dataIndex: "comment",
      width: "15rem",
      key: "comment",
      render: (text: string) => (
        <div style={{display: "flex", flexWrap: "wrap"}}>
          <p>{`${text.substring(0, 200)}${text.length > 200 ? "..." : ""}`}</p>
          {text.length > 200 && (
            <Button
              onClick={() => {
                showModal(text);
              }}
              type="text"
              size="small"
              style={{padding: 0}}
            >
              <span style={{textDecoration: "underline"}}>Read more</span>
            </Button>
          )}
        </div>
      ),
    },
    {
      title: "Offering",
      dataIndex: "offering",
      width: "17rem",
      key: "offering",
      render: (text, record) => (
        <>
          <p>{text}</p>
        </>
      ),
    },

    {
      title: "Rating",
      dataIndex: "rating",
      width: "17rem",
      key: "rating",
      render: (text) => (
        <>
          <Space size={8} direction="vertical" style={{display: "flex"}}>
            <Rate
              disabled
              defaultValue={Number(text)}
              style={{
                color: "#99C78F",
              }}
              allowHalf
            />
            <p>
              {text}/5 {handleRatingText(Number(text))}
            </p>
          </Space>
        </>
      ),
    },
    {
      title: "Date",
      dataIndex: "date",
      width: "15rem",
      key: "date",
      render: (text) => (
        <>
          <StyledDescriptionText>
            {moment(text).format("ddd, MMM DD YYYY")}
          </StyledDescriptionText>
        </>
      ),
    },
  ];

  const reviewsData: DataType[] = reviews.map((r) => ({
    comment: r.review,
    customer: `${r.first_name} ${r.last_name}`,
    date: r.createdAt,
    email: r.email_address,
    key: r.id,
    offering: r.offering_name,
    rating: `${r.rating}`,
  }));

  return (
    <div>
      <Table
        columns={columns}
        dataSource={reviewsData}
        scroll={{x: 100}}
        pagination={false}
      />
      <Modal
        title="Comment"
        visible={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
      >
        <StyledModalContentWrapper>
          <p>{commentModalDetails}</p>
        </StyledModalContentWrapper>
      </Modal>
    </div>
  );
}
